import { Button, Card } from "react-bootstrap";
import styled from "styled-components";

const StyledCardGrey = styled(Card)`
    border: none;
    border-radius: 8px;
    background: #f0f2f2;
`;

const StyledCardEmpty = styled(Card)`
    font-size: 16px;
    color: #404040;
    border: 1px solid #e4e4e4;
    border-radius: 8px;
    box-shadow: 0 0.125rem 0.25rem rgb(0 0 0 / 8%);
    span {
        vertical-align: middle;
    }
    svg {
        width: 18px;
        height: 18px;
        fill: #404040;
        vertical-align: middle;
        margin-right: 0.5rem;
    }
`;

const StyledCardActivityPlan = styled(Card)`
    border: 1px solid #e4e4e4;
    border-left: 3px solid #a16000;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
`;

const StyledCardTitle = styled.span`
    font-weight: 600;
    font-size: 15px;
    color: #9654ff;
    margin: 0;
    width: auto;
`;

const StyledCardAvailableHours = styled.div`
    font-size: 15px;
    font-weight: 400;
    text-align: center;
    padding: 0px 10px;
    gap: 8px;
    background: #9654ff;
    border-radius: 32px;
    color: #ffff;
    max-width: 140px;
    margin-left: 10px;
    margin-right: 10px;
    display: inline-grid;
`;

const StyledCardTeacher = styled.p`
    font-weight: 600;
    font-size: 17px;
    line-height: 150%;
    color: #1e1e1e;
    margin-top: 8px !important;
    margin-bottom: 5px;
`;

const StyledCardHour = styled.p`
    font-weight: 400;
    font-size: 18px;
    color: #1e1e1e;
    padding-right: 8px;
    margin: 0;
    display: flex;
    align-items: center;
`;

const StyledDefaultButtonLink = styled(Button)`
    background: #fff;
    border: none;
    color: #8a0538;
    font-weight: 600;
    font-size: 16px;
    > a {
        color: inherit;
        text-decoration: inherit;
    }
    > svg {
        fill: #8a0538;
        width: 17px;
        height: 17px;
    }
    &:hover {
        background: #fff !important;
        border: none;
        color: #8a0538 !important;
        > svg {
            fill: #8a0538 !important;
        }
    }
    &.btn:focus {
        outline: none;
        box-shadow: none;
        background: #fff !important;
        border: none;
        color: #8a0538 !important;
        > svg {
            fill: #8a0538;
        }
    }
    &.btn:active {
        outline: none;
        box-shadow: none;
        background: #fff !important;
        border: none;
        color: #8a0538 !important;
        > svg {
            fill: #8a0538;
        }
    }
    &:disabled {
        background: #e4e4e4;
        border: none;
        color: #404040;
        font-weight: 600;
        font-size: 16px;
        > svg {
            fill: #787878;
        }
    }
`;

export {
    StyledCardGrey,
    StyledCardEmpty,
    StyledCardActivityPlan,
    StyledCardTitle,
    StyledCardTeacher,
    StyledCardHour,
    StyledCardAvailableHours,
    StyledDefaultButtonLink,
};
